<template>
    <div>
        <v-simple-table dense class="header-contrast no-hover border-last-row border-header-row">
            <thead>
                <th class="pl-4 pa-2 pl-2 text-left">Kostentype</th>
                <th class="pr-4 pa-2 w-3 text-right">Bedrag</th>
                <th class="pa-1 w-1 "></th>
            </thead>
            <tbody>
                <tr v-if="!model.budgetcosts.length">
                    <td colspan="4">Er zijn geen kostenregels gemaakt</td>
                </tr>
                
                <tr v-for='(line, index) in model.budgetcosts' :key='`bc-${index}`'>
                    <td class="pa-1">
                        <CostTypeCombo no-border scopen="true" sccreate="false" :model='model' placeholder="Kostentype" v-model='line.id_costtype'></CostTypeCombo>
                    </td>
                    <td class="pa-1">
                        <NumberField no-border amount :model='model' v-model='line.amount' ></NumberField>
                    </td>
                    <td class="pa-0">                 
                        <ActionButton ml dusk='btn-line-remove' :model="model" icon-button icon="remove" 
                            action="project.modify" @click="() => removeLine(line)">
                        </ActionButton>
                    </td>
                </tr>

            </tbody>
            <tfoot class="border-top">
                <td class="pa-2 pl-4">
                    <ActionButton :model="model" action="project.modify" sub dusk="btn-add-costline" icon="add" @click='(evt)=>addLine(evt)'>Nieuwe kostenregel</ActionButton>
                </td>
                <td class="pr-4 text-right text-bold">
                    <AmountText v-if="model.budgetcosts.length" v-model='model.totalCosts'/>    
                </td>
                <td ></td>
            </tfoot>
        </v-simple-table>
    </div>
</template>

<script setup>
    import NumberField from '@controls/input/NumberField'
    import ActionButton from '@controls/buttons/ActionButton'
    import CostTypeCombo from '@controls/combo/CostType'
    import AmountText from '@controls/text/Amount.vue'

    import {ref} from 'vue'

    const props = defineProps({
        model: {
            type: [Object]
        },
    });

    function addLine(evt) {
        props.model.addCostLine();
    }
    function removeLine(item) {
        props.model.removeCostLine(item);
    }



</script>